import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatTableFilterButtonComponent } from './mat-table-filter-button/mat-table-filter-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableFilterComponent } from './mat-table-filter.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';


@NgModule({
  declarations: [MatTableFilterComponent, MatTableFilterButtonComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    MatInputModule,
    MatBadgeModule,
    ReactiveFormsModule
  ],
  exports: [MatTableFilterComponent, MatTableFilterButtonComponent]
})
export class MatTableFilterModule { }
